/**
 * Labstep
 *
 * @module components/EntityView/Action/Delete
 * @desc Action to delete EntityView
 */

import { EntityActionDelete as ActionDelete } from 'labstep-web/components/Entity/Action/Delete';
import { navigation } from 'labstep-web/services/navigation';
import type React from 'react';
import { withRouter } from 'react-router-dom';
import type { EntityViewActionDeleteProps } from './types';

export const EntityViewActionDelete: React.FC<
  EntityViewActionDeleteProps
> = ({ entityView, history }) => (
  <ActionDelete
    options={{
      onSuccess: (): void => {
        if (entityView.context === 'reporting') {
          history.push(navigation.get('entity_view_index'));
        } else {
          window.location.reload();
        }
      },
    }}
    header={
      entityView.context !== 'reporting'
        ? 'Reset the view to default'
        : undefined
    }
    confirmMessage={
      entityView.context !== 'reporting'
        ? 'Are you sure you want to reset the view to default?'
        : undefined
    }
    customActionText={
      entityView.context !== 'reporting'
        ? 'Reset the view to default'
        : undefined
    }
    customIconName="refresh"
    actionComponentProps={
      entityView.context !== 'reporting'
        ? {
            type: 'text',
          }
        : undefined
    }
    entity={entityView}
  />
);

export default withRouter(EntityViewActionDelete);
